// WHY [BOL-SUMMARY-JUMP-001]: the human asked for a Summary button in the counts
// strip that jumps to the last summary in the Chat log (Goal 2 item 5). A summary
// turn is recognised from the operator's own request wording; the scheduled
// 06:00/18:00 summaries (Goal 2 item 1) will tag their turns explicitly through
// the same attribute. This is navigation only: it never decides meaning or proof.
// The jump itself runs inside the chat component (it listens for the event
// below) so it can release auto-follow exactly like an operator scroll; a
// scripted scroll from outside lost a race against the settle-to-latest frame.
// Falsifier: the button lands on a non-summary turn, snaps back to the latest
// turn, or does nothing when a summary turn exists.
export const SUMMARY_PROMPT_PATTERN = /\bsummar(?:y|ies|ise|ize|ised|ized|ising|izing)\b/iu;
export const SUMMARY_JUMP_EVENT = "ops-summary-jump";
export const SUMMARY_TURN_SELECTOR = "article.ops-turn[data-ops-summary=\"true\"]";
/** A successful final answer, never the request, progress, loading or failure block. */
export const SUMMARY_ANSWER_SELECTOR = ".ops-message--assistant.ops-message--answer";

export function isSummaryPrompt(prompt: string | null | undefined): boolean {
  return typeof prompt === "string" && SUMMARY_PROMPT_PATTERN.test(prompt);
}

/** The newest tagged summary with an actual answer inside the thread, or null. */
export function findLatestSummaryTurn(root: ParentNode): HTMLElement | null {
  const turns = root.querySelectorAll<HTMLElement>(SUMMARY_TURN_SELECTOR);
  // WHY [BOL-SUMMARY-JUMP-COMPLETED-001]: a newer scheduled summary can fail
  // (e.g. usage limit) while the previous summary remains useful. Request tags
  // alone sent the Summary button to that failure or a pending/cancelled turn.
  // Use the existing successful-response DOM class, not semantic text matching;
  // retain the in-component scroll/auto-follow ownership below.
  for (let index = turns.length - 1; index >= 0; index -= 1) {
    const turn = turns[index];
    if (turn?.querySelector(SUMMARY_ANSWER_SELECTOR)) return turn;
  }
  return null;
}

/** WHY (human, 2026-09-15): “go to the most recent actual summary”, so the jump
    lands on the answer text of that turn, never on the request bubble above it. */
export function summaryJumpTarget(turn: HTMLElement): HTMLElement {
  return turn.querySelector<HTMLElement>(SUMMARY_ANSWER_SELECTOR) ?? turn;
}

/** Asks the mounted chat to jump; returns whether a summary turn exists to jump to. */
export function requestSummaryJump(root: ParentNode = document, target: EventTarget = window): boolean {
  if (!findLatestSummaryTurn(root)) return false;
  target.dispatchEvent(new Event(SUMMARY_JUMP_EVENT));
  return true;
}
